module.exports = __webpack_public_path__ + "assets/svg/Icons/32/time-blue-bc1a39.svg";